var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleRadius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53375 4.83925C10.588 5.43972 10.588 6.95932 9.53375 7.55979L3.13326 11.2055C2.08964 11.7999 0.792992 11.0463 0.792992 9.84522V2.55381C0.792992 1.35277 2.08964 0.599099 3.13326 1.19354L9.53375 4.83925Z",
    fill: "#E7B92A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRadius);
export default __webpack_public_path__ + "static/media/triangle-radius.75f3f7bf30c795bb38016e119429fe12.svg";
export { ForwardRef as ReactComponent };